// src/admin/components/Skeleton.tsx
import styles from './Skeleton.module.css';
export default function Skeleton({ w = '100%', h = 14 }: { w?: string | number; h?: number }) {
  return <span className={styles.skel} style={{ width: w, height: h }} />;
}
